import $ from "jquery";
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);


var iswithport = false;
var port_folder = ":5932";
if(!iswithport){
  port_folder = "/prolacsrv";
}


var backend_url,doc_download_url;
if(!isLocalhost){
  backend_url = window.location.origin+port_folder
}else{
  backend_url = "http://localhost:8090"
}

export const API_BASE_URL = backend_url;
//export const API_BASE_URL = "https://carmis.pmis.app/carmissrv";